var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThreeDiamonds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 7.071,
    height: 7.071,
    rx: 1,
    transform: "rotate(-45 0 5)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 7.071,
    height: 7.071,
    rx: 1,
    transform: "rotate(-45 20 5)",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 7.071,
    height: 7.071,
    rx: 1,
    transform: "rotate(-45 40 5)",
    fill: "currentColor"
  })));
}

export default SvgThreeDiamonds;